import { File, User } from '../../../../data/entities';
import { CircularProgress, TableRow } from '@mui/material';
import { StyledTableCell } from '../../../../shared/components/CustomTable/Styled';
import { formatDate } from '../../../../utils/dateUtils';
import DeleteIcon from '../../../../shared/svg/DeleteIcon';
import { api } from '../../../../shared/hooks/api';
import { error, success } from '../../../../utils/toast';
import apiMethods from '../../../../utils/api';
import { StyledNavLink } from '../../../../shared/styled/TableStyles';
import { getFileTypeIcon } from '../../utils/fileTypeIcon';

interface FileProps {
    item: File;
    extraRowProps: any;
}

export const FileRow = ({ item, extraRowProps }: FileProps) => {
    const documentId = item.id;
    const documentName = item.filename_original || item.filename || 'N/A';
    
    // Parse FileLink to get linked object
    let refId = 'N/A';
    let linkPath = '';
    
    if (item.links && item.links.length > 0) {
        const link = item.links[0];
        refId = link.object_id;
        
        // Use meta for display name if available
        if (link.meta && link.meta.object_name) {
            refId = link.meta.object_name;
        }
        
        // Map content_type to route path
        const contentType = link.content_type.toLowerCase();
        if (contentType === 'product_flow.saleorder') {
            linkPath = `/product-orders/${link.object_id}`;
        } else if (contentType === 'materials.materialorder') {
            linkPath = `/material-orders/${link.object_id}`;
        } else if (contentType === 'products.productorder') {
            linkPath = `/product-orders/${link.object_id}`;
        } else if (contentType === 'products.product') {
            linkPath = `/products/${link.object_id}`;
        } else if (contentType === 'materials.material') {
            linkPath = `/materials/${link.object_id}`;
        } else if (contentType === 'products.customer') {
            linkPath = `/customers/${link.object_id}`;
        }
    }

    // Get customer name and ID from meta
    let customer = 'N/A';
    let customerId = null;
    if (item.links && item.links.length > 0 && item.links[0].meta) {
        const meta = item.links[0].meta;
        if (meta.customer_name) {
            customer = meta.customer_name;
        }
        if (meta.customer_id) {
            customerId = meta.customer_id;
        }
    }
    
    const uploader: any = item.uploader || { id: 'N/A', display_name: 'N/A' };

    const [{ isDeleting }, deleteFile] = api.delete(`/files/${documentId}/`);

    const handleDownload = async () => {
        try {
            const downloadUrl = `/files/${documentId}/download/`;
            
            // Fetch to get the SAS URL
            const response: any = await apiMethods.get(downloadUrl);
            
            if (response.download_url) {
                // Open SAS URL directly
                window.open(response.download_url, '_blank');
                success("THÀNH CÔNG", "Đang tải xuống tệp tin...");
            } else {
                throw new Error('No download URL returned');
            }
        } catch (err) {
            error("Tải xuống tệp tin thất bại", err);
        }
    };

    const onClickDeleteItem = async () => {
        if (isDeleting) return;
        try {
            await deleteFile();
            await extraRowProps.fetchItems();
            success('THÀNH CÔNG', 'Xóa tệp tin thành công');
        } catch (err) {
            error("Lỗi xóa tập tin", err);
        }
    };

    return (
        <TableRow>
            <StyledTableCell
                onClick={handleDownload}
                sx={{
                    cursor: 'pointer',
                    '&:hover': { textDecoration: 'underline' },
                    height: '52px',
                    verticalAlign: 'middle',
                }}
            >
                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {getFileTypeIcon(documentName, (item as any).mime_type)}
                    {documentName}
                </span>
            </StyledTableCell>
            <StyledTableCell>
                {refId !== 'N/A' && linkPath ? (
                    <StyledNavLink to={linkPath}>
                        {refId}
                    </StyledNavLink>
                ) : refId}
            </StyledTableCell>
            <StyledTableCell>{formatDate(new Date(item.created_at))}</StyledTableCell>
            <StyledTableCell>
                {customerId ? (
                    <StyledNavLink to={`/customers/${customerId}`}>
                        {customer}
                    </StyledNavLink>
                ) : customer}
            </StyledTableCell>
            <StyledTableCell>
                {uploader.id !== 'N/A' ? (
                    <StyledNavLink to={`/users/${uploader.id}`}>
                        {uploader.display_name || uploader.username || 'N/A'}
                    </StyledNavLink>
                ) : (
                    'N/A'
                )}
            </StyledTableCell>
            <StyledTableCell
            >
                <div
                    style={{cursor: isDeleting ? 'not-allowed' : 'pointer'}}
                    onClick={() => !isDeleting && onClickDeleteItem()}
                    aria-disabled={isDeleting}
                >
                    {isDeleting ? <CircularProgress size={18} /> : <DeleteIcon />}
                </div>
            </StyledTableCell>
        </TableRow>
    );
};
